// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea-root-898460491fb68a0d4e9fef2fff7599f2","fullwidth":"Textarea-fullwidth-3952b85a91a0c36786e9877df4a2c4eb"};